import React from 'react';
import './MenuList.css';

import { MenuItem, EmptyState, PageTitle } from '../../../components';
import { useFilterLoading, useMenuFilter } from '../../../utils';
import { eventMenu, menu } from '../../../constants';

import { FaUtensils } from 'react-icons/fa';

import { useLocation } from 'react-router-dom';



const MenuList = () => {

  const location = useLocation();

  // Retrieve the menu type (e.g., 'general' or 'event') from the route state
  const menuType = location.state?.menuType || 'general';

  // Select the appropriate menu data
  const menuData = menuType === 'event' ? eventMenu : menu;

  // Custom hook to handle menu item filtering logic
  const {
    searchKeyword,
    matchingItems,
  } = useMenuFilter(menuData);

  // Custom hook to check if filtering is in progress
  const isFiltering = useFilterLoading(matchingItems, searchKeyword);

  return (
    <>
      <PageTitle title={'Menu List'} page={'Menu List'} />
    
      <section className="menu">

          {/* Conditional rendering based on filter state and results */}
          {isFiltering ? null : matchingItems.length === 0 ? (

            // Show empty state if no matching items are found
            <EmptyState
              icon={FaUtensils}
              title={`No menu items found for "${searchKeyword}"`}
              message="We couldn't find any dishes that match your search. Please try a different keyword or explore our full menu."
              buttonLink="Menu-Tabs"
              buttonText="Browse Full Menu"
            />
          ) : (
            // Render the filtered list of menu items
            <div className="box-container">
              {matchingItems.map(item => (
                <MenuItem key={item.id} item={item} />
              ))}
            </div>
          )}
      </section>
    </>
  );
};

export default MenuList;